import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import DropVoteProgressing from "@/components/drops/view/utils/DropVoteProgressing";
interface MyStreamWaveMyVoteVotesProps {
  readonly drop: ExtendedDrop;
}
const MyStreamWaveMyVoteVotes: React.FC<MyStreamWaveMyVoteVotesProps> = t0 => {
  const $ = _c(11);
  const {
    drop
  } = t0;
  const isPositive = drop.rating >= 0;
  const t1 = `tw-text-sm tw-font-bold tw-font-mono tw-tracking-tight ${isPositive ? "tw-text-emerald-500" : "tw-text-rose-500"}`;
  let t2;
  if ($[0] !== drop.rating) {
    t2 = formatNumberWithCommas(drop.rating);
    $[0] = drop.rating;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <span className={t1}>{t2}</span>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== drop.rating || $[6] !== drop.rating_prediction) {
    t4 = <DropVoteProgressing current={drop.rating} projected={drop.rating_prediction} />;
    $[5] = drop.rating;
    $[6] = drop.rating_prediction;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div className="tw-flex tw-items-center tw-gap-x-1.5">{t3}{t4}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
export default MyStreamWaveMyVoteVotes;